import { CONTENT_MAX_WIDTH } from "@/lib/useDeviceType";
import { useEffect, useState } from "react";
import { Dimensions } from "react-native";

const BASE_PADDING = 16;

/** Left inset for full-bleed carousels aligned to the centered content column. */
export function useCarouselLeftPadding(): number {
  const [screenWidth, setScreenWidth] = useState(
    Dimensions.get("window").width,
  );

  useEffect(() => {
    const subscription = Dimensions.addEventListener("change", ({ window }) => {
      setScreenWidth(window.width);
    });
    return () => subscription?.remove();
  }, []);

  return screenWidth > CONTENT_MAX_WIDTH
    ? (screenWidth - CONTENT_MAX_WIDTH) / 2 + BASE_PADDING
    : BASE_PADDING;
}
